export default {
    namespaced: true,

    state: {
        tickets: [],
        addOns: [],
        kabanas: []
    },

    getters: {
        getTicketById: state => id => {
            const ticket = state.tickets.find(ticket => ticket.id === id)

            if (ticket) {
                return JSON.parse(JSON.stringify(ticket))
            }

            return null
        },

        getAddOnById: state => id => {
            const addOn = state.addOns.find(addOn => addOn.id === id)

            if (addOn) {
                return JSON.parse(JSON.stringify(addOn))
            }

            return null
        },

        getKabanaById: state => id => {
            const kabana = state.kabanas.find(kabana => kabana.id === id)

            if (kabana) {
                return JSON.parse(JSON.stringify(kabana))
            }

            return null
        }
    },

    mutations: {
        setTickets (state, tickets) {
            state.tickets = tickets
        },

        setAddOns (state, addOns) {
            state.addOns = addOns
        },

        setKabanas (state, kabanas) {
            state.kabanas = kabanas
        }
    },

    actions: {
        async fetchTickets (context) {
            const mockTickets = [
                {
                    id: 'TK-0',
                    ProductName: 'Adult Day Pass',
                    description: '(Height 122cm and above)',
                    productType: 'Ticket',
                    price: 780,
                    status: 'active'
                },
                {
                    id: 'TK-1',
                    ProductName: 'Children Day Pass',
                    description: '(Height 111 cm - under 122 cm)',
                    productType: 'Ticket',
                    price: 520,
                    status: 'inactive'
                },
                {
                    id: 'TK-2',
                    ProductName: 'Senior Day Pass',
                    description: '(Age 60 yrs. & up)',
                    productType: 'Ticket',
                    price: 780,
                    status: 'active'
                },
                {
                    id: 'TK-3',
                    ProductName: 'Family Package',
                    description: 'Free 1 Child Ticket with Paid 2 Adults (Height 111 cm - under 122 cm)',
                    productType: 'Ticket',
                    price: 2400,
                    status: 'active'
                }
            ]
            context.commit('setTickets', mockTickets)
        },

        async fetchAddOns (context) {
            const mockAddOns = [
                {
                    id: 'AD-0',
                    ProductName: 'Towel',
                    description: '',
                    productType: 'Add-on',
                    price: 20,
                    status: 'active'
                },
                {
                    id: 'AD-1',
                    ProductName: 'Locker',
                    description: '',
                    productType: 'Add-on',
                    price: 20,
                    status: 'active'
                },
                {
                    id: 'AD-2',
                    ProductName: 'Cabana',
                    description: '',
                    productType: 'Add-on',
                    price: 300,
                    status: 'inactive'
                }
            ]

            context.commit('setAddOns', mockAddOns)
        },

        async fetchKabanas (context) {
            const mockKabanas = [
                {
                    id: 'KB-0',
                    ProductName: 'Kabana1',
                    description: '',
                    productType: 'Kabana',
                    price: 500,
                    status: 'active'
                }
            ]

            context.commit('setKabanas', mockKabanas)
        }
    }
}
